var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextstopsNextstepsIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1992_4894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0156 61.014V67",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4297 67V61.014",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 66.9999V57.8294C23.2656 54.8058 25.717 52.3557 28.7393 52.3557H37.7054C40.7291 52.3557 43.1791 54.8071 43.1791 57.8294V66.9999",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0047 47.9129C36.4073 47.9129 39.1656 45.1546 39.1656 41.752C39.1656 38.3494 36.4073 35.5911 33.0047 35.5911C29.6021 35.5911 26.8438 38.3494 26.8438 41.752C26.8438 45.1546 29.6021 47.9129 33.0047 47.9129Z",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 61.0562V55.0703",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 61.0563V51.8858C5.4375 48.8622 7.88884 46.4121 10.9112 46.4121H19.8773C21.3361 46.4121 22.6621 46.9831 23.6431 47.9131",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2592 36.7982C21.8044 33.4396 19.5236 30.2749 16.165 29.7297C12.8064 29.1846 9.6417 31.4653 9.09652 34.8239C8.55133 38.1826 10.8321 41.3472 14.1907 41.8924C17.5493 42.4376 20.714 40.1568 21.2592 36.7982Z",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69938 45.2291C2.14095 41.4799 1.28125 37.3679 1.28125 33.0567C1.28125 15.5051 15.5269 1.27734 33.0989 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2891 25.4561C17.2192 12.1455 25.6999 1.27734 33.0974 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5938 61.0562V55.0703",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7525 61.0563V51.8858C60.7525 48.8622 58.3011 46.4121 55.2788 46.4121H46.3127C44.8539 46.4121 43.5279 46.9831 42.5469 47.9131",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9931 41.889C55.3517 41.3439 57.6325 38.1792 57.0873 34.8206C56.5421 31.4619 53.3775 29.1812 50.0188 29.7264C46.6602 30.2715 44.3795 33.4362 44.9246 36.7948C45.4698 40.1535 48.6345 42.4342 51.9931 41.889Z",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4933 45.2291C64.0517 41.4799 64.9114 37.3679 64.9114 33.0567C64.9114 15.5051 50.6658 1.27734 33.0938 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9021 25.4561C48.9719 12.1455 40.4912 1.27734 33.0938 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0938 1.41284L33.1129 29.8735",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 18.4343H61.3733",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1992_4894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.1901,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextstopsNextstepsIcon2);
export default __webpack_public_path__ + "static/media/nextstops_nextsteps_icon2.71e638d12d85c1b71b6bd71dd583fb88.svg";
export { ForwardRef as ReactComponent };